document.addEventListener('DOMContentLoaded', function() {
  // Find the original Add to Cart button section
  const addToCartForm = document.querySelector('form.product-single__form');
  if (!addToCartForm) return;

  const originalButton = addToCartForm.querySelector('[data-add-to-cart]');
  // if (!originalButton) return;

  // Enhanced check for sold out status using multiple signals
  const isProductSoldOut = document.querySelector('.product__price--sold-out') !== null || 
    (originalButton && 
      (originalButton.disabled || 
       originalButton.querySelector('[data-add-to-cart-text]')?.textContent.trim() === 'Sold')
    );

  // Try to get product data from window object first
  let productData;
  let currentVariant;

  if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
    productData = window.ShopifyAnalytics.meta.product;
    console.log('Found product data in ShopifyAnalytics.meta');
  } else if (window.meta && window.meta.product) {
    productData = window.meta.product;
    console.log('Found product data in window.meta');
  } else if (window.Shopify && window.Shopify.product) {
    productData = window.Shopify.product;
    console.log('Found product data in Shopify.product');
  }

  // Get initial price - prefer data from JSON if available
  let priceText = '';
  let priceAmount = 0;
  let currencySymbol = '£';

  if (productData && productData.variants && productData.variants.length > 0) {
    if (window.Shopify && window.Shopify.currentVariant) {
      currentVariant = window.Shopify.currentVariant;
    } else {
      currentVariant = productData.variants[0];
    }
    priceAmount = currentVariant.price;
    const priceElement = document.querySelector('span[data-product-price] .money');
    if (priceElement && priceElement.textContent.trim().length > 0) {
      currencySymbol = priceElement.textContent.trim().charAt(0);
    }
    priceText = currencySymbol + (priceAmount / 100).toFixed(2);
    console.log('Initial price from JSON:', priceText);
  } else {
    const priceElement = document.querySelector('span[data-product-price] .money');
    if (priceElement) {
      priceText = priceElement.textContent.trim();
      console.log('Found price from DOM:', priceText);
      if (priceText.length > 0) {
        currencySymbol = priceText.charAt(0);
      }
    } else {
      const fallbackPriceElement = document.querySelector('[data-product-price]');
      if (fallbackPriceElement) {
        const priceContent = fallbackPriceElement.textContent.trim();
        if (priceContent.includes('£') && priceContent.split('£').length > 2) {
          priceText = '£' + priceContent.split('£')[1].trim();
        } else {
          priceText = priceContent;
        }
      } else {
        priceText = '£3,545.00'; // Default fallback
      }
    }
  }

  // Get the lead time
  let leadTimeText = '';
  let hasLeadTime = false;
  const leadTimeDataElement = document.querySelector('[data-lead-time]');
  if (leadTimeDataElement) {
    leadTimeText = leadTimeDataElement.getAttribute('data-lead-time');
    hasLeadTime = leadTimeText && leadTimeText.trim() !== '';
    console.log('Found lead time in data attribute:', leadTimeText);
  }
  if (!hasLeadTime) {
    const salesPointElement = document.querySelector('.product-block--sales-point .sales-point');
    if (salesPointElement) {
      const fullText = salesPointElement.textContent.trim();
      if (fullText.includes('Made to order')) {
        const startIndex = fullText.indexOf('Made to order');
        leadTimeText = fullText.substring(startIndex)
          .replace(/.a\{fill:none;stroke:#000;stroke-width:2px\}/g, '')
          .trim();
        hasLeadTime = leadTimeText && leadTimeText.trim() !== '';
      }
    }
  }
  if (hasLeadTime && leadTimeText && !leadTimeText.includes('Made to order')) {
    leadTimeText = `Made to order: ${leadTimeText}`;
  }

  // START: Add Subtotal and Lead Time to Static ATC
  const staticProductInfoContainer = document.createElement('div');
  staticProductInfoContainer.className = 'static-product-order-info';
  // --- STYLE CHANGE FOR INLINE LAYOUT ---
  staticProductInfoContainer.style.display = 'flex';
  staticProductInfoContainer.style.justifyContent = 'space-between'; // Pushes items to ends
  staticProductInfoContainer.style.alignItems = 'center'; // Vertically aligns items
  staticProductInfoContainer.style.marginBottom = '15px';
  staticProductInfoContainer.style.width = '100%'; // Ensure it takes full width to allow space-between

  const staticSubtotalElement = document.createElement('div');
  staticSubtotalElement.className = 'static-product-subtotal';
  
  // Set content based on sold out status
  if (isProductSoldOut) {
    staticSubtotalElement.textContent = 'Sold';
    staticSubtotalElement.classList.add('static-product-subtotal--sold-out');
  } else {
    staticSubtotalElement.textContent = 'Subtotal: ' + priceText;
  }
  
  staticSubtotalElement.style.fontSize = '18px';
  // staticSubtotalElement.style.marginRight = 'auto'; // Pushes lead time to the right if needed with different justify-content

  staticProductInfoContainer.appendChild(staticSubtotalElement);

  if (hasLeadTime && !isProductSoldOut) {
    const staticDeliveryElement = document.createElement('div');
    staticDeliveryElement.className = 'static-product-delivery';
    staticDeliveryElement.textContent = leadTimeText;
    staticDeliveryElement.style.backgroundColor = '#f9f9f4';
    staticDeliveryElement.style.padding = '5px 10px';
    staticDeliveryElement.style.borderRadius = '3px';
    staticDeliveryElement.style.fontSize = '14px';
    staticDeliveryElement.style.color = '#666';
    // staticDeliveryElement.style.marginLeft = 'auto'; // Alternative to space-between on parent
    staticProductInfoContainer.appendChild(staticDeliveryElement);
  }

  if (originalButton && originalButton.parentNode) {
    originalButton.parentNode.insertBefore(staticProductInfoContainer, originalButton);
  } else if (addToCartForm) {
    addToCartForm.insertBefore(staticProductInfoContainer, addToCartForm.firstChild);
  }
  // END: Add Subtotal and Lead Time to Static ATC

  const stickyOrderBar = document.createElement('div');
  stickyOrderBar.className = 'sticky-order-bar';
  
  // Set sticky bar content based on sold out status
  if (isProductSoldOut) {
    stickyOrderBar.innerHTML = `
      <div class="sticky-order-container">
        <div class="sticky-order-top">
          <div class="sticky-subtotal sticky-subtotal--sold-out">Sold</div>
        </div>
        <button type="button" class="sticky-add-button btn--full btn add-to-cart" disabled>Sold Out</button>
      </div>
    `;
  } else {
    stickyOrderBar.innerHTML = `
      <div class="sticky-order-container">
        <div class="sticky-order-top">
          <div class="sticky-subtotal">Subtotal: ${priceText}</div>
          ${hasLeadTime ? `<div class="sticky-delivery">${leadTimeText}</div>` : ''}
        </div>
        <button type="button" class="sticky-add-button btn--full btn add-to-cart">Add to cart</button>
      </div>
    `;
  }
  
  document.body.appendChild(stickyOrderBar);

  const stickyButton = stickyOrderBar.querySelector('.sticky-add-button');
  if (stickyButton && !isProductSoldOut) {
      stickyButton.addEventListener('click', function() {
        if (originalButton) {
            originalButton.click();
        } else if (addToCartForm) { // Ensure addToCartForm exists before submitting
            addToCartForm.submit();
        }
      });
  }

  const getProductHandle = () => {
    const pathParts = window.location.pathname.split('/');
    if (pathParts.includes('products')) {
      return pathParts[pathParts.indexOf('products') + 1];
    }
    return null;
  };

  const updatePriceDisplay = (price, available = true) => {
    if (available) {
      const formattedPrice = currencySymbol + (price / 100).toFixed(2);
      const stickySubtotal = stickyOrderBar.querySelector('.sticky-subtotal');
      if (stickySubtotal) {
        stickySubtotal.textContent = 'Subtotal: ' + formattedPrice;
        stickySubtotal.classList.remove('sticky-subtotal--sold-out');
      }
      const staticSubtotal = document.querySelector('.static-product-subtotal');
      if (staticSubtotal) {
        staticSubtotal.textContent = 'Subtotal: ' + formattedPrice;
        staticSubtotal.classList.remove('static-product-subtotal--sold-out');
      }
      
      // Update button status
      const stickyButton = stickyOrderBar.querySelector('.sticky-add-button');
      if (stickyButton) {
        stickyButton.textContent = 'Add to cart';
        stickyButton.disabled = false;
      }
      
      console.log('Price updated to:', formattedPrice);
    } else {
      // Update to "Sold" when variant is not available
      const stickySubtotal = stickyOrderBar.querySelector('.sticky-subtotal');
      if (stickySubtotal) {
        stickySubtotal.textContent = 'Sold';
        stickySubtotal.classList.add('sticky-subtotal--sold-out');
      }
      const staticSubtotal = document.querySelector('.static-product-subtotal');
      if (staticSubtotal) {
        staticSubtotal.textContent = 'Sold';
        staticSubtotal.classList.add('static-product-subtotal--sold-out');
      }
      
      // Update button status
      const stickyButton = stickyOrderBar.querySelector('.sticky-add-button');
      if (stickyButton) {
        stickyButton.textContent = 'Sold Out';
        stickyButton.disabled = true;
      }
      
      console.log('Product marked as sold out');
    }
  };

  document.addEventListener('variant:change', function(event) {
    if (event.detail && event.detail.variant) {
      updatePriceDisplay(event.detail.variant.price, event.detail.variant.available);
    }
  });
  document.addEventListener('variantChange', function(event) {
    if (event.detail && event.detail.variant && event.detail.variant.price) {
      updatePriceDisplay(event.detail.variant.price, event.detail.variant.available);
    }
  });

  const priceObserverTarget = document.querySelector('[data-product-price]');
  if (priceObserverTarget) {
    const priceObserver = new MutationObserver(function(mutations) {
      // Check if product is now showing as sold out
      const soldOutElement = document.querySelector('.product__price--sold-out');
      if (soldOutElement) {
        updatePriceDisplay(0, false); // Mark as sold out
        return;
      }
      
      // Also check for button state changes
      if (originalButton && originalButton.disabled) {
        updatePriceDisplay(0, false); // Mark as sold out
        return;
      }
      
      // Check button text for "Sold"
      const buttonText = originalButton?.querySelector('[data-add-to-cart-text]')?.textContent.trim();
      if (buttonText === 'Sold') {
        updatePriceDisplay(0, false); // Mark as sold out
        return;
      }
      
      const newPriceElement = priceObserverTarget.querySelector('.money');
      if (newPriceElement) {
        const newPriceText = newPriceElement.textContent.trim();
        const stickySubtotal = stickyOrderBar.querySelector('.sticky-subtotal');
        if (stickySubtotal && newPriceText) {
          stickySubtotal.textContent = 'Subtotal: ' + newPriceText;
        }
        const staticSubtotalForObserver = document.querySelector('.static-product-subtotal');
        if (staticSubtotalForObserver && newPriceText) {
          staticSubtotalForObserver.textContent = 'Subtotal: ' + newPriceText;
        }
        console.log('Price updated via DOM observer to:', newPriceText);
      }
    });
    priceObserver.observe(priceObserverTarget, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  let ticking = false;
  function updatePositions() {
    const footer = document.querySelector('.site-footer');
    if (!footer) return { footerTop: 9999999 };
    const footerRect = footer.getBoundingClientRect();
    const footerTop = footerRect.top + window.pageYOffset;
    return { footerRect, footerTop };
  }
  let positions = updatePositions();
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      positions = updatePositions();
    }, 100);
  });
  let lastScrollPosition = window.pageYOffset;
  let lastScrollDirection = null;
  stickyOrderBar.classList.add('visible');
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        positions = updatePositions();
        const currentScrollPosition = window.pageYOffset;
        const scrollingDown = currentScrollPosition > lastScrollPosition;
        const scrollDirection = scrollingDown ? 'down' : 'up';
        const viewportHeight = window.innerHeight;
        const distanceToFooter = positions.footerTop - (currentScrollPosition + viewportHeight);
        const footerVisible = distanceToFooter < 100;
        if (scrollDirection === 'down') {
          stickyOrderBar.classList.remove('visible');
        } else if (scrollDirection === 'up' && !footerVisible) {
          stickyOrderBar.classList.add('visible');
        }
        lastScrollPosition = currentScrollPosition;
        lastScrollDirection = scrollDirection;
        ticking = false;
      });
      ticking = true;
    }
  });

  const styleElement = document.createElement('style');
  styleElement.textContent = `
    .sticky-order-bar {
      position: fixed; bottom: 0; right: 0; width: 100%;
      background: #FFFFFF; border-top: 1px solid #f0f0f0;
      z-index: 999; transform: translateY(100%);
      transition: transform 0.3s ease; opacity: 0; visibility: hidden;
      padding: 30px; box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
    }
    .sticky-order-bar.visible { transform: translateY(0); opacity: 1; visibility: visible; }
    .sticky-order-container { width: 100%; display: flex; flex-direction: column; gap: 15px; }
    .sticky-order-top { display: flex; justify-content: space-between; align-items: center; width: 100%; }
    .sticky-subtotal { font-size: 18px; font-weight: normal; }
    .sticky-delivery {
      background-color: #f9f9f4; padding: 5px 10px; border-radius: 3px;
      font-size: 14px; color: #666;
    }
    .sticky-add-button {
      width: 100% !important; flex: 1 1 auto !important; -webkit-appearance: none; -moz-appearance: none;
      background: #000000; border: 1px solid transparent; border-radius: 0;
      color: #FFFFFF; cursor: pointer; display: block;
      font-size: calc(var(--typeBaseSize, 16px) + 2px); font-weight: 700;
      line-height: 1.42; margin: 0; padding: 10px 20px; text-align: center;
      text-decoration: none; user-select: none;
    }
    
    /* Disabled button style */
    .sticky-add-button:disabled {
      opacity: 0.65;
      cursor: not-allowed;
      background-color: #cccccc;
    }

    /* Sold out style */
    .sticky-subtotal--sold-out,
    .static-product-subtotal--sold-out {
      font-weight: 700;
      font-size: 18px;
      color: #b3a87d; /* Gold color to match your existing sold out style */
    }

    /* --- CSS FOR STATIC PRODUCT INFO --- */
    .static-product-order-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%; /* Or based on parent container */
        margin-bottom: 15px; /* Space before ATC button */
    }
    .static-product-subtotal {
        /* Styles already applied via JS, can be moved here */
        font-size: 18px;
    }
    .static-product-delivery {
        /* Styles already applied via JS, can be moved here */
        background-color: #f9f9f4;
        padding: 5px 10px;
        border-radius: 3px;
        font-size: 14px;
        color: #666;
    }
    /* --- END CSS FOR STATIC PRODUCT INFO --- */


    @media only screen and (min-width: 769px) {
      .sticky-order-bar { width: 40%; padding: 30px; right: 0; }
      /* Static info already flexed by default now */
    }
    @media (max-width: 768px) {
      .sticky-order-bar { width: 100%; right: auto; left: 0; padding: 15px; }
      .sticky-order-top { flex-direction: column; align-items: center; gap: 10px; }
      .sticky-subtotal, .sticky-delivery { text-align: center; width: 100%; }
      .sticky-delivery { padding: 10px 20px; width: auto; display: inline-block; }

      /* For mobile, if you want static info to stack like sticky bar's top section: */
      /*
      .static-product-order-info {
        flex-direction: column;
        align-items: center;
        gap: 10px;
      }
      .static-product-subtotal, .static-product-delivery {
         width: 100%;
         text-align: center;
      }
      .static-product-delivery {
         width: auto;
      }
      */
      /* If you want them to remain inline on mobile but maybe wrap: */
      .static-product-order-info {
        flex-wrap: wrap; /* Allow wrapping if not enough space */
        gap: 10px; /* Add some gap if they wrap */
      }
    }
  `;
  document.head.appendChild(styleElement);
});